const cohortClauseActions = {
  CLONE_COHORT_CLAUSE: 'CLONE_COHORT_CLAUSE',
  HIDE_RENAME_CLAUSE: 'HIDE_RENAME_CLAUSE',
  REMOVE_COHORT_CLAUSE: 'REMOVE_COHORT_CLAUSE',
  SHOW_RENAME_CLAUSE: 'SHOW_RENAME_CLAUSE',
  UPDATE_ACTIVE_CLAUSE_PROPERTIES: 'UPDATE_ACTIVE_CLAUSE_PROPERTIES',
  UPDATE_CLAUSE_PANELS: 'UPDATE_CLAUSE_PANELS',
};

export default cohortClauseActions;
